/**
 * @desc 根据tmsno，生成推送EBS的数据，用来修数据
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.ResponseDto<Array<string>>;
export function request(
  params: API.tms.exportDeclaration.debugEbsJson.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/exportDeclaration/debug/ebs/json`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
